import { styled, Box } from '@mui/material';

export const WageIndexationHalfGridContainer = styled(Box)(({ theme }) => ({
  width: '49.5%',
  marginTop: theme.spacing(3),
  height: '55vh',
  '& .Mui-error': {
    color: theme.palette.error.main,
  },
}));

export const WageIndexationGridContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  height: '55vh',
  '& .Mui-error': {
    color: theme.palette.error.main,
  },
}));

export const ConfirmButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  marginTop: theme.spacing(2),
}));

export const CompanyWageIndexationGridContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(8),
  height: '55vh',
  '& .Mui-error': {
    color: theme.palette.error.main,
  },
}));

export const IndexationFilterContainer = styled(Box)(() => ({
  background: 'white',
  padding: '10px 32px 10px 32px',
  marginTop: '10px',
  borderRadius: '8px',
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
  maxHeight: 'auto',
}));

export const FLOW_STEP_HEIGHT_VH = 90;

export const IndexationFlowContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  height: `${FLOW_STEP_HEIGHT_VH}vh`,
}));

export const WageIndexationFlowButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '20px',
  padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
  marginLeft: 'auto',
}));

export const WageIndexationFlowStepContainer = styled(Box)<{ activeStep?: number }>(({ activeStep }) => ({
  width: '100%',
  height: `${FLOW_STEP_HEIGHT_VH}vh`,
  /**
   * Flex items shrink by default, so in the 90vh column each step was collapsing to roughly a
   * third of itself, floored by its own content. On a tall viewport that left the active step
   * shorter than the window and the next one visible below it.
   */
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  transition: 'transform 0.75s ease-in-out',
  transform: `translateY(${activeStep * -FLOW_STEP_HEIGHT_VH}vh)`,
}));

export const WageIndexationFlowCard = styled(Box)(({ theme }) => ({
  width: '100%',
  borderRadius: '4px',
  backgroundColor: 'white',
  padding: theme.spacing(2.5),
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  maxHeight: '800px',
  overflowY: 'auto',
}));
